import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="termsPage" data-testid="termsPage" />
  );
};

export default Terms;
